"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuraVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class AuraVfxStepArgs {
    constructor(applyAt, type) {
        this.applyAt = applyAt;
        this.type = type;
        this.__typeName = "Aura";
        this.id = (0, uuid_1.v4)();
    }
}
exports.AuraVfxStepArgs = AuraVfxStepArgs;
